namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderShippingReportGrid extends Serenity.EntityGrid<OrderShippingReportRow, any> {
        rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumnsKey() { return OrderShippingReportColumns.columnsKey; }
        protected getDialogType() { return OrderShippingReportDialog; }
        protected getIdProperty() { return OrderShippingReportRow.idProperty; }
        protected getInsertPermission() { return OrderShippingReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderShippingReportRow.localTextPrefix; }
        protected getService() { return OrderShippingReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderShippingReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Print Address Without Specifications',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var orderIds = this.getSelectedOrderIds();
                    if (orderIds.length == 0) {
                        Q.alert("Please select at least 1 Order to print Address!");
                        return;
                    } else {
                        Q.postToService({
                            url: Q.resolveUrl('~/PrintInvoice/PrintAddress?OrderIds=' + orderIds.join(',')),
                            request: '',
                            target: '_blank'
                        });
                    }
                }
            });
            buttons.push({
                title: 'Print Address With Specifications',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var orderIds = this.getSelectedOrderIds();
                    if (orderIds.length == 0) {
                        Q.alert("Please select at least 1 Order to print Address!");
                        return;
                    } else {
                        Q.postToService({
                            url: Q.resolveUrl('~/PrintInvoice/PrintAddressWithSpecification?OrderIds=' + orderIds.join(',')),
                            request: '',
                            target: '_blank'
                        });
                    }
                }
            });
            return buttons;
        }

        private getSelectedOrderIds(): string[] {
            return this.rowSelection.getSelectedKeys().map(key => {
                var item = this.view.getItemById(key);
                return item.OrderNumber;
            });
        }
        protected getItemCssClass(item: Reports.OrderShippingReportRow, index: number): string {
            let klass: string = "";
            if (item.BookStatus == RioERP.Web.Enums.EBookStatus.Added)
                klass += " added";

            if (item.BookStatus == RioERP.Web.Enums.EBookStatus.NotAdded)
                klass += " notadded";

            else if (item.BookStatus == RioERP.Web.Enums.EBookStatus.AllBooksAdded)
                klass += " allbooksadded";

            return Q.trimToNull(klass);
        }

    }
}
